export const rescheduleReducer = (state, action) => {
  switch (action.type) {
    case 'OPEN_CANCEL_APPOINTMENT_MODAL':
      return {
        ...state,
        openCancelAppointmentModal: true,
        isCancelled: true,
      };
    case 'SHOW_SURVEY':
      return {
        ...state,
        showSurvey: true,
        typeButton: 'Reschedule',
      };
    case 'CANCEL':
      return {
        ...state,
        wantsToCancel: true,
      };
    case 'CLOSE_CANCEL_APPOINTMENT_MODAL':
      return {
        ...state,
        openCancelAppointmentModal: false,
      };
    case 'HANDLE_BUTTON_TYPE':
      return {
        ...state,
        typeButton: action.button || 'initial',
      };
    case 'ERROR_IN_CANCELLATION':
      return {
        ...this.state,
        openCancelAppointmentModal: false,
        isCancelled: false,
        isCancelling: false,
      };
    case 'START_LOADING_FOR_CANCELLATION':
      return {
        ...state,
        isCancelling: true,
      };
    case 'STOP_LOADING_FOR_CANCELLATION':
      return {
        ...state,
        isCancelling: false,
      };
    default:
      return state;
  }
};
